import { navigateToUrl } from 'single-spa';

declare var bootstrap: any;
export const showModal = (id: string) => {
  let modalInstance = bootstrap.Modal.getInstance(document.getElementById(id));
  if (!modalInstance) {
    modalInstance = new bootstrap.Modal(document.getElementById(id));
  }
  modalInstance.show();
};

export const hideModal = (id: string) => {
  let modalInstance = bootstrap.Modal.getInstance(document.getElementById(id));
  if (modalInstance) {
    modalInstance.hide();
  }
};

export const pushQueries = (queries: Record<string, string>) => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  Object.entries(queries).forEach(([key, value]) => {
    urlSearchParams.set(key, value);
  });
  navigateToUrl(`${window.location.pathname}?${urlSearchParams.toString()}`);
};

export const removeQueries = (keys: string[]) => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  keys.forEach((k) => {
    if (urlSearchParams.has(k)) {
      urlSearchParams.delete(k);
    }
  });
  navigateToUrl(`${window.location.pathname}?${urlSearchParams.toString()}`);
};

export * from './colors';
export * from './const';
export * from './Convert';
export * from './Currency';
export * from './DateTime';
export * from './DateTime/date';
export * from './Option';
export * from './Title';
